import React from 'react';
import PropTypes from 'prop-types';
import R from 'ramda';
import Heading from '@cotyorg/ccx-atoms/Heading';
import Paragraph from '@cotyorg/ccx-atoms/Paragraph';
import { HeroFullBlock } from '@cotyorg/ccx-organism-hero';
import SectionHeader from '../../../../atoms/SectionHeader';

export const Science = ({ sectionHeadings }) => (
  <div className="science-section">
    <div className="science-section__hero">
      <HeroFullBlock
        heroStoreDataKey="science"
        isContentFirst
        isUnderlined={false}
      />
    </div>

    <div className="grid-container">
      <div className="grid-x grid-margin-x">
        <div className="cell under-space">
          <SectionHeader>
            <Heading extraClass="section__title" level={2}>
              {R.path(['science', 'heading'])(sectionHeadings)}
            </Heading>

            <Paragraph>
              {R.path(['science', 'introduction'])(sectionHeadings)}
            </Paragraph>
          </SectionHeader>
        </div>
      </div>
    </div>
  </div>
);

Science.propTypes = {
  sectionHeadings: PropTypes.instanceOf(PropTypes.object),
};
